<template>
  <the-navbar-button v-bind="$props">
    <template #default>
      <v-subheader
        style="height: auto;"
        class="text-subtitle-2 font-weight-regular py-1 px-2 font--text"
        v-on="$listeners"
        v-text="$i18n.t(`navbar.${name}`, { customName: customName })"
      />
    </template>
  </the-navbar-button>
</template>

<script>
import TheNavbarButton from '@/components/TheNavbarButton';

export default {
  name: 'TheNavbarTopPanelMenuButton',
  components: {
    TheNavbarButton,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    customName: {
      type: String,
      required: false,
    },
    isToolWorking: {
      type: Boolean,
      default: true,
    },
    hasCustomAction: {
      type: Boolean,
      default: false,
    },
    routeParams: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped></style>
